import { useEffect } from 'react'
import { useStencilNavigation } from './useStencilNavigation'

export const useStencilActiveSlug = (slug: string) => {
  const { setActiveSlug } = useStencilNavigation()

  useEffect(() => {
    setActiveSlug(slug)

    return () => {
      setActiveSlug(null)
    }
  }, [slug, setActiveSlug])
}
